import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { PlanTooltipComponent } from './plan-tooltip.component';

@NgModule({
	declarations: [PlanTooltipComponent],
	imports: [CommonModule, TooltipModule],
	exports: [PlanTooltipComponent],
})
export class PlanTooltipModule {}
